const businessDiagnosisDictPT = {
  businessDiagnosis: "Avaliação da empresa",
  businessDiagnosisSubtitle:
    "Caro empresário, a seguir você encontrará uma série de perguntas para tornar sua empresa ainda mais EFICIENTE, EFICAZ, ECONÔMICA e SUSTENTÁVEL. Engenho, dedicação, profissionalismo e compartilhamento permitirão que vocês façam um caminho virtuoso juntos.",

  businessDiagnosisMenuSelection: "Menu de seleção",

  businessDiagnosisInProgress: "Diagnóstico da empresa em pausa",
  businessDiagnosisProgressDescription:
    "Descubra como tornar sua empresa mais acessível e sustentável.",
  businessDiagnosisProgressLabel: "Progresso:",
  businessDiagnosisProgressStep: "Fase {current} de {total}",
  businessDiagnosisContinue: "Continuar o Diagnóstico",

  businessDiagnosisStep1Title: "Dados da Empresa",
  businessDiagnosisStep2Title: "Estrutura da Empresa",
  businessDiagnosisStep3Title: "Tamanho da Empresa",
  businessDiagnosisStep4Title: "Capital Humano por Gênero",
  businessDiagnosisStep5Title: "Capital Humano por Funções",
  businessDiagnosisStep6Title: "Capital Humano",
  businessDiagnosisStep7Title: "Representações",
  businessDiagnosisStep8Title: "Outras Informações",

  businessDiagnosisStep1Description:
    "Insira os dados gerais da sua empresa para nos ajudar a entender sua identidade e o contexto em que você opera.",
  businessDiagnosisStep2Description:
    "Descreva a composição e a organização interna da sua empresa para compreender sua solidez e capacidade operacional.",
  businessDiagnosisStep3Description:
    "Especifique o tamanho da sua empresa para nos orientar melhor na avaliação de suas necessidades e potencial de crescimento.",
  businessDiagnosisStep4Description:
    "Conte-nos quantos colaboradores sua empresa possui e as competências deles, para valorizar seu capital humano.",
  businessDiagnosisStep5Description:
    "Especifique as principais funções e responsabilidades dos funcionários, destacando os cargos essenciais para o crescimento da empresa.",
  businessDiagnosisStep6Description:
    "Insira dados relacionados ao pessoal empregado na sua empresa, dividido por funções, competências e áreas operacionais.",
  businessDiagnosisStep7Description:
    "Forneça informações sobre quaisquer representantes legais ou comerciais da sua empresa, tanto em nível nacional quanto internacional.",
  businessDiagnosisStep8Description:
    "Explique como sua empresa utiliza ferramentas tecnológicas e estratégias inovadoras para permanecer competitiva.",

  back: "Voltar",
  saveAndContinue: "Salvar e continuar",
  sendDiagnosis: "Enviar Diagnóstico",

  businessDiagnosisConsent: "Eu consinto",
  businessDiagnosisConsentText:
    "I consent to the use of the information provided for a free assessment for the EXTRACONOMY platform and authorize the processing of data in accordance with current legislation and GDPR.",

  // Shared helpers
  select: "Selecionar",
  businessDiagnosisNoData: "—",

  // Step 1
  businessDiagnosisStep1LabelCompanyName: "Razão Social",
  businessDiagnosisStep1LabelRegisteredOffice: "Sede Legal",
  businessDiagnosisStep1LabelAddress: "Endereço",
  businessDiagnosisStep1LabelVatNumber: "Número de IVA",
  businessDiagnosisStep1LabelAtecoCode: "Código ATECO",
  businessDiagnosisStep1LabelSector: "Setor",
  businessDiagnosisStep1LabelLegalRepresentative: "Representante Legal",
  businessDiagnosisStep1LabelPhone: "Telefone",
  businessDiagnosisStep1LabelAdministrativeRepresentative: "Representante Administrativo",
  businessDiagnosisStep1LabelWebsite: "Site",
  businessDiagnosisStep1PlaceholderWebsite: "https://",
  businessDiagnosisStep1LabelEmail: "E-mail",
  businessDiagnosisStep1LabelCompanyDescription: "Breve descrição da empresa",
  businessDiagnosisStep1PlaceholderCompanyDescription:
    "Breve descrição da missão e das atividades.",
  businessDiagnosisStep1LabelLawFirm: "Escritório de advocacia",
  businessDiagnosisStep1LabelAccountingFirm: "Escritório contábil",
  businessDiagnosisStep1LabelLaborConsultant: "Consultor trabalhista",

  // Step 2
  businessDiagnosisStep2OrganizationalChartLabel: "Organigrama",
  businessDiagnosisStep2OrganizationalChartHelp: "A empresa tem um organigrama?",
  businessDiagnosisStep2CompanyRegulationsLabel: "Regulamento da Empresa",
  businessDiagnosisStep2CompanyRegulationsHelp: "Existe um regulamento interno?",
  businessDiagnosisStep2OrganizationalModel231Label: "Modelo Organizacional 231/01",
  businessDiagnosisStep2OrganizationalModel231Help: "Adota o Modelo 231/01?",
  businessDiagnosisStep2ModelOt23Label: "Modelo OT23 - ISI INAIL",
  businessDiagnosisStep2ModelOt23Help: "A empresa aplica modelos OT23/INAIL?",
  businessDiagnosisStep2CodeOfEthicsLabel: "Código de Ética",
  businessDiagnosisStep2CodeOfEthicsHelp: "A empresa tem um código de ética?",
  businessDiagnosisStep2LegalityRatingLabel: "Classificação de Legalidade",
  businessDiagnosisStep2LegalityRatingHelp: "Obteve uma classificação de legalidade?",
  businessDiagnosisStep2SustainabilityReportLabel: "Relatório/Balanço de Sustentabilidade",
  businessDiagnosisStep2SustainabilityReportHelp: "Publica relatórios de sustentabilidade?",
  businessDiagnosisStep2SecondaryOfficesLabel: "Unidades secundárias",
  businessDiagnosisStep2SecondaryOfficesHelp: "Existem unidades secundárias?",
  businessDiagnosisStep2SecondaryOfficesWhere: "Se sim, indicar onde",
  businessDiagnosisStep2IndustryAssociationLabel: "Filiação a associações do setor",
  businessDiagnosisStep2IndustryAssociationHelp: "Adesão a associações do setor.",
  businessDiagnosisStep2IndustryAssociationWhich: "Se sim, indicar quais",
  businessDiagnosisStep2InterprofessionalFundsLabel: "Fundos Interprofissionais",
  businessDiagnosisStep2InterprofessionalFundsHelp: "Participação em fundos interprofissionais.",
  businessDiagnosisStep2InterprofessionalFundsWhich: "Se sim, indicar quais",
  businessDiagnosisStep2BilateralEntityLabel: "Entidade Bilateral",
  businessDiagnosisStep2BilateralEntityHelp: "Está inscrita em uma entidade bilateral?",
  businessDiagnosisStep2BilateralEntityWhich: "Se sim, indicar qual",

  // Step 3
  businessDiagnosisStep3LabelEmployees: "Nº de Funcionários",
  businessDiagnosisStep3EmployeesHelp:
    "Indique o tamanho da empresa com base no número de funcionários.",
  businessDiagnosisStep3LabelRevenue: "Faturamento",
  businessDiagnosisStep3RevenueHelp: "Indique a faixa de faturamento anual.",

  businessDiagnosisSizeEmployeesMicro: "Microempresa (<10)",
  businessDiagnosisSizeEmployeesSmall: "Pequena empresa (10-49)",
  businessDiagnosisSizeEmployeesMedium: "Média empresa (50-249)",
  businessDiagnosisSizeEmployeesLarge: "Grande empresa (250+)",

  businessDiagnosisSizeRevenueLte2: "Até 2 milhões",
  businessDiagnosisSizeRevenue2To10: "2 a 10 milhões",
  businessDiagnosisSizeRevenue10To50: "10 a 50 milhões",
  businessDiagnosisSizeRevenueGt50: "Mais de 50 milhões",

  // Step 4
  businessDiagnosisStep4LabelTotalEmployees: "Nº TOTAL DE FUNCIONÁRIOS",
  businessDiagnosisStep4LabelWomen: "Mulheres",
  businessDiagnosisStep4GenderDistributionHelp: "Distribuição de gênero.",
  businessDiagnosisStep4LabelMen: "Homens",
  businessDiagnosisStep4LabelOtherGender: "Outro gênero",

  // Step 5
  businessDiagnosisStep5InternalHrLabel: "RH interno",
  businessDiagnosisStep5InternalHrHelp:
    "Indicar se existe um escritório ou responsável interno de RH.",
  businessDiagnosisStep5SecondLevelContractLabel: "Contrato de 2º nível",
  businessDiagnosisStep5SecondLevelContractHelp:
    "Indicar se a empresa aplica contratos de segundo nível (integrações ao CCNL).",
  businessDiagnosisStep5OngoingLaborDisputesLabel: "Conflitos trabalhistas em andamento",
  businessDiagnosisStep5OngoingLaborDisputesHelp:
    "Indicar se há conflitos trabalhistas atualmente em andamento.",
  businessDiagnosisStep5ConcludedLaborDisputesLabel: "Conflitos trabalhistas concluídos",
  businessDiagnosisStep5ConcludedLaborDisputesHelp:
    "Indicar se a empresa concluiu conflitos trabalhistas no passado.",
  businessDiagnosisStep5UnionRepresentativesLabel: "Representantes Sindicais",
  businessDiagnosisStep5UnionRepresentativesHelp:
    "Indicar se há representantes sindicais ativos na empresa.",
  businessDiagnosisStep5UnionRepresentativesWhichLabel: "Se sim, indicar quais",
  businessDiagnosisStep5UnionRepresentativesWhichHelp:
    'Se você respondeu "SIM" acima, especificar quais contratos, conflitos ou representantes.',
  businessDiagnosisStep5AppliedCcnlLabel: "CCNL aplicado",
  businessDiagnosisStep5AppliedCcnlPlaceholder:
    "Indique qual CCNL (Contrato Coletivo Nacional de Trabalho) é aplicado na empresa.",

  // Step 6
  businessDiagnosisStep6StaffingAgenciesLabel: "Uso de agências de emprego",
  businessDiagnosisStep6StaffingAgenciesHelp:
    "Indique se a empresa utiliza agências externas para seleção e gestão de pessoal.",
  businessDiagnosisStep6DirectSeveranceLabel: "Gestão direta do TFR",
  businessDiagnosisStep6DirectSeveranceHelp:
    "Informe se a empresa gerencia internamente a indenização por tempo de serviço (TFR).",
  businessDiagnosisStep6UseTfmLabel: "Uso de políticas TFM",
  businessDiagnosisStep6UseTfmHelp:
    "Especifique se a empresa utiliza políticas TFM (Trattamento di Fine Mandato) para administradores.",
  businessDiagnosisStep6UseKmanLabel: "Uso de políticas KMAN",
  businessDiagnosisStep6UseKmanHelp:
    "Indique se existem apólices de seguro KMAN ativas para figuras-chave da empresa.",
  businessDiagnosisStep6CorporateWelfareLabel: "Bem-estar corporativo",
  businessDiagnosisStep6CorporateWelfareHelp:
    "Indique se a empresa oferece um plano de bem-estar corporativo (benefícios e serviços para os funcionários).",
  businessDiagnosisStep6HealthWelfareLabel: "Bem-estar em saúde",
  businessDiagnosisStep6HealthWelfareHelp:
    "Informe se a empresa oferece planos ou serviços de bem-estar em saúde aos funcionários.",

  // Step 7
  businessDiagnosisStep7RsaLabel: "RSA - Representante sindical da empresa",
  businessDiagnosisStep7RsaHelp:
    "Indique se a empresa tem um representante sindical apenas para os sindicalizados.",
  businessDiagnosisStep7RsuLabel: "RSU - Representante sindical unitário",
  businessDiagnosisStep7RsuHelp:
    "Indique se existe um representante que proteja todos os trabalhadores, sindicalizados e não sindicalizados.",
  businessDiagnosisStep7RpsLabel: "RPS - Representante de Segurança",
  businessDiagnosisStep7RpsHelp:
    "Especifique se os trabalhadores nomearam um representante de segurança.",
  businessDiagnosisStep7RsppLabel: "RSPP - Responsável de Segurança e Prevenção",
  businessDiagnosisStep7RsppHelp:
    "Indicar se o empregador nomeou um responsável por segurança e prevenção.",
  businessDiagnosisStep7RsppNameLabel: "Nome do RSPP (indicar)",
  businessDiagnosisStep7RsppNamePlaceholder: "Escreva o nome da pessoa nomeada como RSPP.",
  businessDiagnosisStep7DvrLabel: "DVR - Documento de Avaliação de Riscos",
  businessDiagnosisStep7DvrHelp: "Documento de avaliação de riscos.",
  businessDiagnosisStep7DuvriLabel:
    "DUVRI - Documento Único de Avaliação de Riscos de Interferência",
  businessDiagnosisStep7DuvriHelp:
    "Indique se há o documento que avalia os riscos decorrentes das atividades de terceiros na empresa.",

  // Step 8
  businessDiagnosisStep8LabelSocialMediaPresence: "Presença em redes sociais",
  businessDiagnosisStep8LabelECommerce: "E-commerce",
  businessDiagnosisStep8LabelGenderEqualityCertification: "Certificação de Igualdade de Gênero",
  businessDiagnosisStep8LabelIso: "ISO",
  businessDiagnosisStep8IsoWhichLabel: "Indicar quais",
  businessDiagnosisStep8LabelCyberSecurity: "Segurança cibernética",
  businessDiagnosisStep8LabelGdpr: "GDPR",
  businessDiagnosisStep8LabelSubsidizedFinance: "Uso de Financiamento Subsidiado",
  businessDiagnosisStep8LabelFundedTraining: "Uso de Formação Financiada",
  businessDiagnosisStep8LabelHasLiquidityManager: "Você tem um gestor de liquidez da empresa?",
  businessDiagnosisStep8LabelDiversifiedLiquidityWithGold:
    "Você diversificou a liquidez da empresa comprando ouro?",
  businessDiagnosisStep8LabelDate: "Data: ",
  businessDiagnosisStep8LabelConsultant: "Consultor: ",
};

export default businessDiagnosisDictPT;
